module.exports = __webpack_public_path__ + "static/img/4-5.cd8f6cfa.jpg";